<template>
    <div class="modal fade text-left" :id="id" tabindex="-1" role="dialog"
            aria-labelledby="myModalLabel160" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" :class="`modal-${size}`" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-primary white">
                        <h5 class="modal-title" id="myModalLabel160">{{ title }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                    <div class="modal-footer" v-if="$slots['footer']">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

export default {
    name: 'ModalB4',
    props: {
        title: {
            type: String,
            default: 'No title'
        },
        id: {
            type: String,
            default: 'ModalB4'
        },
        size: {
            type: String,
            default: 'lg'
        }
    },
    methods: {
        open() {
            this.$refs.modal.show();
        },
        close() {
            this.$refs.modal.hide();
        }
    }
}
</script>